<template>
    <div ref="adBoxContainer" :class="`ad-w360-h217-index ${!isResponsive?'ad-w360-h217-other':''}`" >
        <div v-show="!isCloseAd">
            <div v-if="source===2" ref="googleIndexAdLeft" class="google-index-activity-left">
                <ins class="adsbygoogle"
                     style="display:inline-block;width:360px;height:217px;"
                     :data-ad-client="googleDataAdClient"
                     :data-ad-slot="googleDataAdSlot"
                     ref="googleIndexAdIns"
                ></ins>
            </div>
            <div class="speed-activity-box-warp-left" v-if="source===1||source===3||source===6">
                <img @click="openAdDetail" class="speed-activity-img-left" v-if="imgSrc" :src="imgSrc" alt="icon"/>
            </div>
            <!--百度广告-->
            <div v-if="source===4" ref="baiduIndexAdLeft" :class="`${baiduAdContainer} baidu-index-ad-left`"></div>
        </div>
        <img class="no-banner-image"  :src="noAdBgcSrcLists[noAdImgIndex]" v-if="noAdImgIndex!==-1&&(source===0||source===2)"  alt="no-banner-image">
    </div>
</template>

<script>
import pubAdMixins from "../../mixin/pubAdMixins";

export default {
    mixins:[pubAdMixins],
};
</script>
<style lang="scss" scoped>
.ad-w360-h217-index {
    width: 22.5rem;
    height: 13.563rem;
    overflow: hidden;
    position: relative;
    .google-index-activity-left,.baidu-index-ad-left{
        width: 100%;
        height: 100%;
        transform-origin: 0 0;
    }
    .speed-activity-box-warp-left{
        width: 100%;
        height: 100%;
        .speed-activity-img-left{
            margin-top: 0;
            width: 100%;
            height: 100%;
        }
    }
    .no-banner-image{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: -1;
        margin: 0 !important;
    }
}
.ad-w360-h217-other{
    width: 360px;
    height: 217px;
}
.close-ad{
    display: none;
}
</style>




// WEBPACK FOOTER //
// resources/js/components/ads/adW360H217.vue